import React from "react";
import { useWTReportDateColumns } from "./useWTReportDateColumns";
import { AccessRights } from "../../../core/navigation/types";
import { TradeList } from "../../../data/trading/trades/types";
import { Table, TableDataProps } from "../../components/common/Table";
import { WeeklyTradingReportData } from "../../../data/reports/weeklyTrade/types";
import { useReportDateData } from "../../../data/reports/weeklyTrade/hooks/useReportDateData";
import { useWeeklyActions } from "./useWeeklyActions";

export interface WeeklyTradesTableProps {
  userAccessRights: AccessRights;
}

type WeeklyTradesTablePropsType = WeeklyTradesTableProps &
  TableDataProps<TradeList>;

const WTRDateTable: React.FunctionComponent<WeeklyTradesTablePropsType> = ({
  userAccessRights,
  ...tableProps
}) => {
  const columns = useWTReportDateColumns();
  const [data, load, reset] = useReportDateData();
  React.useEffect(() => reset, [reset]);

  return (
    <Table<WeeklyTradingReportData>
      {...tableProps}
      getData={load}
      immutableData={data}
      title=""
      columns={columns}
      //      actions={actions}
      options={{
        actionsColumnIndex: -1,
        search: false,
        toolbar: false,
      }}
    />
  );
};

export default WTRDateTable;
